export const MPO_RECOMMENDED_PLAN_ID = 1;
export const PLAN_NAME_MAX_LENGTH = 30;
export const MPO_SUPPORT_URL =
  'https://support.measured.com/article/dgtiuodr5t-media-plan-optimizer-using-mpo-alpha-concepts';
export const MPO_PLAN_SETTINGS_SUPPORT_URL =
  'https://support.measured.com/article/dgtiuodr5t-media-plan-optimizer-using-mpo-alpha-concepts#plan_settings';
export const MPO_SEASONALITY_SUPPORT_URL =
  'https://support.measured.com/article/dgtiuodr5t-media-plan-optimizer-using-mpo-alpha-concepts#seasonality';
export const DEFAULT_OPTIMIZE_FOR_DAYS = 30;
export const MIN_OPTIMIZE_FOR_DAYS = 1;
export const MAX_OPTIMIZE_FOR_DAYS = 180;
export const PLAN_PERIOD_MAX_DAYS_BACK = 365;
export const DUPLICATE_PREFIX = 'Copy of ';

// MPO Field and Dimension Constants
export enum MPOFieldNames {
  conversionType = 'conversionType',
  tactic = 'tactic',
  channel = 'channel',
  budget = 'budget',
  budgetAdjustment = 'budgetAdjustment',
  returnCurve = 'returnCurve',
  salesINetGain = 'salesINetGain',
  segment = 'segment',
  modelResult = 'modelResult'
}

export enum MPOModalTypes {
  tactic = 'tactic',
  channel = 'channel'
}

export enum MPOQueryStatuses {
  success = 'success',
  error = 'error',
  pending = 'pending'
}

export enum MPOOptimizationTypes {
  custom = 'custom'
}

export enum MPOFilterNames {
  relativeDate = 'relativeDate',
  day = 'day'
}

export enum MPOKeys {
  Escape = 'Escape',
  Enter = 'Enter'
}

export enum MPOClasses {
  budgetAdjustmentBudgetColumn = 'budget-adjustment-budget-column'
}

// Chart Constants
export enum MPOChartLabels {
  mediaSpend = 'Media Spend',
  totalMediaSpend = 'Total Media Spend',
  incrementalSales = 'Incremental Sales',
  incrementalOrders = 'Incremental Orders',
  totalSales = 'Total Sales',
  totalOrders = 'Total Orders',
  targetBudget = 'Target Budget',
  referenceBudget = 'Reference Budget',
  roas = 'ROAS',
  cpo = 'CPO'
}

export const PLAN_CHART_TARGET_BUDGET_SERIES_ID = 'planChartTargetBudget';
export const PLAN_CHART_REFERENCE_BUDGET_SERIES_ID = 'planChartReferenceBudget';

export enum MPOChartTypes {
  spline = 'spline',
  scatter = 'scatter',
  line = 'line'
}

export enum MPOConversionTypeDefinition {
  base = 'BASE',
  rollupShared = 'ROLLUP_SHARED',
  rollupUnique = 'ROLLUP_UNIQUE'
}

export const ICON_COLORS = [
  'text-blue-300',
  'text-yellow-400',
  'text-green-400',
  'text-red-200',
  'text-orange-100',
  'text-yellow-500',
  'text-green-500',
  'text-red-300',
  'text-yellow-600',
  'text-green-600'
] as const;
